module.exports = __webpack_public_path__ + "img/pro_eight_6.8bdd642f.jpg";